import request from '@/utils/httpClient'

import { RolesModel } from '@/model/Index'
export const defaultRolesModel: RolesModel = {
  id: 0,
  name: '',
  createUser: '',
  updateUser: '',
  createTime: '',
  updateTime: '',
  simpleName: '',
  dataAuthority: '',
  accessIds: []
}

// 创建部门角色
export function createRoles(data?: object) {
  return request({
    url: 'role',
    method: 'POST',
    data
  })
}

// 更新部门角色
export function updateRoles(id: number, data?: object) {
  return request({
    url: `role/${id}`,
    method: 'put',
    data
  })
}

// 批量删除部门角色
export function deleteRolesById(id: number) {
  return request({
    url: `role/${id}`,
    method: 'delete'
  })
}

// 根据部门角色id获取该部门角色下的子部门角色
export function getRoleListByRoleId(id: number, params?: object) {
  return request({
    url: `role/${id}`,
    method: 'get',
    params
  })
}

export function getRoleList(params?: object) {
  return request({
    url: 'role/page',
    method: 'get',
    params
  })
}
